/* RH Produkt-Template: 'mehr lesen'-Kollaps der rh-pd-Beschreibung. */
(function () {
  var haupt = document.querySelector('.rh-pd-haupt');
  var btn = document.querySelector('.rh-pd-mehr');
  if (!haupt || !btn || btn.dataset.rhInit) return;
  btn.dataset.rhInit = '1';
  var sync = function () {
    if (!haupt.classList.contains('is--zu')) return;
    btn.style.display = haupt.scrollHeight > haupt.clientHeight + 40 ? '' : 'none';
  };
  btn.addEventListener('click', function () {
    var zu = haupt.classList.toggle('is--zu');
    btn.classList.toggle('is--offen', !zu);
    btn.querySelector('.rh-pd-mehr-txt').textContent = zu ? btn.dataset.mehr : btn.dataset.weniger;
    if (zu) haupt.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  sync();
  window.addEventListener('load', sync);
})();
